export const GENERIC_SALE_PROCESS_MODULE_NAME = "genericSaleProcess";

export const GENERIC_SALE_PROCESS_GETTER = "get";

export const GENERIC_SALE_PROCESS_CLEAR_STATE = "clear";

export const GENERIC_SALE_PROCESS_SET_PROCESS = "setProcess";

const buildName = (value: string): string => {
	return [GENERIC_SALE_PROCESS_MODULE_NAME, value].join("/");
};

export const GenericSaleProcessStoreActions = {
	CLEAR: buildName(GENERIC_SALE_PROCESS_CLEAR_STATE)
};

export const GenericSaleProcessStoreMutations = {
	SET_PROCESS: buildName(GENERIC_SALE_PROCESS_SET_PROCESS)
};

export const GenericSaleProcessStoreGetters = {
	GET: buildName(GENERIC_SALE_PROCESS_GETTER)
};
